import React, { Component } from "react";

import { classnames, Icon } from "@culturehq/components";

class AccordianRow extends Component {
  constructor(props) {
    super(props);

    const { initialOpen } = props;

    this.state = {
      open: initialOpen
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { onScroll } = this.props;
    const { open } = this.state;

    if (onScroll && open !== prevState.open && open) {
      onScroll();
    }
  }

  handleToggle = () => {
    this.setState(({ open }) => {
      if (open) {
        return { open: false };
      }
      return { open: true };
    });
  };

  handleScroll = event => {
    const { onScroll } = this.props;
    const { target } = event;

    if (onScroll && target.scrollTop + target.offsetHeight + 50 >= target.scrollHeight) {
      onScroll();
    }
  };

  render() {
    const { className, children, upDown } = this.props;
    const { open } = this.state;

    return (
      <>
        <tr className={classnames("Accordian__container", "Accordian__row", className)} onClick={this.handleToggle}>
          <td className="Arrow-column">
            {upDown ? (
              <Icon className="Accordian__arrow" icon={open ? "chevron-up" : "chevron-down"} />
            ) : (
              <Icon className="Accordian__arrow" icon={open ? "chevron-up" : "chevron-right"} />
            )}
          </td>
          {children[0]}
        </tr>

        <tr
          className={`Accordian__body Accordian__body-row ${open ? "open" : "closed"}`}
          onScroll={this.handleScroll}
        >
          {children[1]}
        </tr>
      </>
    );
  }
}

export default AccordianRow;
